/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Meta_TitleInputs */

const en_st_meta_title = /** @type {(inputs: St_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep Studio — proposals, client pages and handover for agencies`)
};

const id_st_meta_title = /** @type {(inputs: St_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep Studio — proposal, halaman klien, dan serah terima untuk agensi`)
};

/**
* | output |
* | --- |
* | "Bystep Studio — proposals, client pages and handover for agencies" |
*
* @param {St_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_meta_title = /** @type {((inputs?: St_Meta_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Meta_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_meta_title(inputs)
	return en_st_meta_title(inputs)
});